
import { useState } from 'react';

const highlights = [
  {
    id: 1,
    year: '2023',
    category: 'Draft',
    title: 'MLB Draft Selection',
    description: 'Selected by the Cleveland Guardians in the 14th round of the 2023 MLB Draft, marking the beginning of his professional baseball career',
    icon: 'ri-trophy-line'
  },
  {
    id: 2,
    year: '2023',
    category: 'Award',
    title: 'Sean Braswell Academic MVP',
    description: 'Honored with the Sean Braswell Academic MVP award at Texas for excellence in academics and athletics',
    icon: 'ri-medal-line'
  },
  {
    id: 3,
    year: '2023',
    category: 'Award',
    title: 'Big 12 Academic First Team',
    description: 'Named to the Big 12 Academic First Team, recognizing outstanding academic achievement while competing at the highest level',
    icon: 'ri-book-line'
  },
  {
    id: 4,
    year: '2024',
    category: 'Honor',
    title: 'All-American Selection',
    description: 'Earned All-American honors for exceptional performance throughout the collegiate season',
    icon: 'ri-star-line'
  },
  {
    id: 5,
    year: '2024',
    category: 'Record',
    title: 'Career-High 14 Strikeouts',
    description: 'Recorded a career-high 14 strikeouts in a single game, showcasing dominant pitching performance',
    icon: 'ri-fire-line'
  },
  {
    id: 6,
    year: '2024',
    category: 'Achievement',
    title: 'College World Series',
    description: "Competed in the College World Series, representing his team on baseball's biggest collegiate stage",
    icon: 'ri-global-line'
  },
  {
    id: 7,
    year: '2024',
    category: 'Honor',
    title: 'First Team All-Conference',
    description: 'Selected to the First Team All-Conference for outstanding performance throughout the season',
    icon: 'ri-shield-star-line'
  },
  {
    id: 8,
    year: '2021',
    category: 'Award',
    title: 'Region 7 NJCAA Pitcher of the Year',
    description: 'Honored as Region 7 NJCAA Pitcher of the Year, recognizing dominance at the junior college level',
    icon: 'ri-trophy-line'
  },
  {
    id: 9,
    year: '2021',
    category: 'Honor',
    title: 'NJCAA All-American Selection',
    description: 'Named NJCAA All-American for outstanding performance during the 2021 season',
    icon: 'ri-star-line'
  },
  {
    id: 10,
    year: '2021',
    category: 'Record',
    title: 'Dyersburg State Strikeout Leader',
    description: 'Led Dyersburg State with 126 strikeouts in 2021, establishing dominance on the mound',
    icon: 'ri-flashlight-line'
  },
  {
    id: 11,
    year: '2022',
    category: 'Achievement',
    title: 'Big 12 Champions',
    description: 'Part of the Big 12 Championship team in 2022, contributing to the conference title',
    icon: 'ri-trophy-line'
  },
  {
    id: 12,
    year: '2022',
    category: 'Achievement',
    title: "NCAA Men's College World Series",
    description: 'Competed in the NCAA Men\'s College World Series in 2022, showcasing talent on the national stage',
    icon: 'ri-global-line'
  },
  {
    id: 13,
    year: '2024',
    category: 'Honor',
    title: 'Filthiest Pitch Highlight Selection',
    description: 'Featured for having one of the filthiest pitches, recognized for devastating pitch movement and effectiveness at the 2022 MCWS',
    icon: 'ri-fire-line',
    link: 'https://www.ncaa.com/news/baseball/article/2022-06-29/here-are-nastiest-pitches-2022-mens-college-world-series'
  },
  {
    id: 14,
    year: '2024',
    category: 'Achievement',
    title: 'A+ Lake County Captains Eastern Conference Champions',
    description: 'Helped lead the Lake County Captains to the Eastern Conference Championship, showcasing elite performance at the A+ level',
    icon: 'ri-trophy-line',
    link: 'https://www.milb.com/lake-county/video/lake-county-secures-first-midwest-title-since-2010'
  },
  {
    id: 15,
    year: '2025',
    category: 'Achievement',
    title: 'Arizona Fall League Champions',
    description: 'Part of the championship team in the prestigious Arizona Fall League, competing against top prospects from across baseball',
    icon: 'ri-trophy-line'
  }
];

const stats = [
  { label: 'Wins', value: '12', icon: 'ri-checkbox-circle-line' },
  { label: 'Strikeouts', value: '167', icon: 'ri-flashlight-line' },
  { label: 'ERA', value: '2.87', icon: 'ri-line-chart-line' },
  { label: 'Innings', value: '109', icon: 'ri-time-line' }
];

const categories = ['Award', 'Achievement', 'Honor', 'Record', 'Draft'];

export default function CareerHighlights() {
  const [activeCategory, setActiveCategory] = useState('Award');

  const filteredHighlights = highlights
    .filter(h => h.category === activeCategory)
    .sort((a, b) => parseInt(b.year) - parseInt(a.year));

  return (
    <section
      id="highlights"
      className="bg-gradient-to-b from-[#0d0d0d] to-[#1a1a1a] py-24 px-6 relative overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute top-20 right-10 w-96 h-96 bg-[#8B0000]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-80 h-80 bg-[#8B0000]/5 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#8B0000]/20 text-[#8B0000] text-sm font-semibold rounded-full mb-4 uppercase tracking-wider">
            The Journey
          </span>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">
            CAREER HIGHLIGHTS
          </h2>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto">
            Key moments and achievements that define the Nightmare&apos;s path to professional baseball
          </p>
        </div>

        {/* Quick Stats Bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[#141414] to-[#1a1a1a] border border-gray-800 rounded-lg p-6 text-center hover:border-[#8B0000]/50 transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 bg-[#8B0000]/10 rounded-full group-hover:bg-[#8B0000]/20 transition-colors">
                <i className={`${stat.icon} text-[#8B0000] text-2xl`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-bold text-white mb-1">
                {stat.value}
              </div>
              <div className="text-gray-500 text-sm uppercase tracking-wider">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Tabs + Content Area */}
        <div className="bg-[#141414] border border-gray-800 rounded-2xl overflow-hidden">
          {/* Tab Bar */}
          <div className="flex border-b border-gray-800 overflow-x-auto">
            {categories.map(category => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`flex-1 min-w-[120px] px-6 py-4 text-sm font-semibold uppercase tracking-wider transition-all duration-300 cursor-pointer whitespace-nowrap relative ${
                  activeCategory === category
                    ? 'text-[#8B0000] bg-[#8B0000]/5'
                    : 'text-gray-500 hover:text-gray-300 hover:bg-white/[0.02]'
                }`}
              >
                {category}
                {activeCategory === category && (
                  <span className="absolute bottom-0 left-0 w-full h-[2px] bg-[#8B0000]"></span>
                )}
                <span className="ml-2 text-xs opacity-60">
                  ({highlights.filter(h => h.category === category).length})
                </span>
              </button>
            ))}
          </div>

          {/* Content */}
          <div className="p-8">
            <div className="space-y-0">
              {filteredHighlights.map((highlight, index) => {
                const isLast = index === filteredHighlights.length - 1;
                const CardWrapper = highlight.link ? 'a' : 'div';
                const cardProps = highlight.link
                  ? {
                      href: highlight.link,
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    }
                  : {};

                return (
                  <CardWrapper
                    key={highlight.id}
                    {...cardProps}
                    className={`group flex items-start gap-6 p-5 rounded-xl hover:bg-white/[0.03] transition-all duration-300 ${
                      highlight.link ? 'cursor-pointer' : ''
                    } block`}
                  >
                    {/* Timeline dot + line */}
                    <div className="flex flex-col items-center flex-shrink-0 pt-1">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#8B0000]/15 group-hover:bg-[#8B0000]/25 transition-colors">
                        <i className={`${highlight.icon} text-[#8B0000] text-lg`}></i>
                      </div>
                      {!isLast && (
                        <div className="w-px h-full min-h-[40px] bg-gray-800 mt-2"></div>
                      )}
                    </div>

                    {/* Content */}
                    <div className="flex-1 min-w-0 pb-4">
                      <div className="flex items-center gap-3 mb-1">
                        <span className="text-xs font-bold text-[#8B0000] bg-[#8B0000]/10 px-2.5 py-0.5 rounded-full">
                          {highlight.year}
                        </span>
                        {highlight.link && (
                          <span className="w-5 h-5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                            <i className="ri-external-link-line text-[#8B0000] text-xs"></i>
                          </span>
                        )}
                      </div>
                      <h3 className="text-lg font-bold text-white group-hover:text-[#8B0000] transition-colors mb-1">
                        {highlight.title}
                      </h3>
                      <p className="text-gray-500 text-sm leading-relaxed">
                        {highlight.description}
                      </p>
                    </div>
                  </CardWrapper>
                );
              })}
            </div>

            {filteredHighlights.length === 0 && (
              <div className="text-center py-12 text-gray-600">
                No highlights in this category yet.
              </div>
            )}
          </div>
        </div>

        {/* Bottom Note */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-2 text-gray-500">
            <i className="ri-arrow-up-line"></i>
            <span className="text-sm">More achievements coming as the journey continues</span>
          </div>
        </div>
      </div>
    </section>
  );
}
